import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'app/auth.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor( private _formBuilder: FormBuilder, private _auth: AuthService, private _router: Router, private _notification: MatSnackBar) {}

  loginData: any;

  clicked: boolean

  ngOnInit(): void {
    this.loginData = this._formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8)]]
    })
  }

  loginUser(submittedData: any){
    this.clicked = true
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if(re.test(submittedData.username)){
      submittedData['email'] = submittedData.username
      delete submittedData.username
    }
    this._auth.login(submittedData).subscribe( data => {
      if(data.status){
        this._auth.saveAccessToken(data.accessToken)
        this._auth.saveRefreshToken(data.refreshToken)
        this._router.navigate(['admin'])
        this.clicked = false
      }
    }, error => {
      if(error.error.error){
        this.openNotification(error.error.error)
      }else if(error.error.message){
        this.openNotification(error.error.message)
      }
      this.clicked = false
    })
  }

  openNotification(msg){
    this._notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

}
